(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ur-aw26-campaign"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSpace = () => {
      const main = document.querySelector('#MainContent:has(.ur-campaign)');
      if (!main || main.dataset.urSpaceBound === 'true') return;
      main.dataset.urSpaceBound = 'true';
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const controller = new AbortController();
      let queued = false;
      const paint = () => {
        queued = false;
        if (!main.isConnected) {
          controller.abort();
          return;
        }
        const offset = reduceMotion.matches ? 0 : -(window.scrollY * 0.12 % 820);
        main.style.setProperty('--ur-space-offset', `${offset}px`);
      };
      const queuePaint = () => {
        if (reduceMotion.matches || queued) return;
        queued = true;
        window.requestAnimationFrame(paint);
      };
      window.addEventListener('scroll', queuePaint, { passive: true, signal: controller.signal });
      reduceMotion.addEventListener('change', paint, { signal: controller.signal });
      paint();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeSpace, { once: true });
    else initializeSpace();
    document.addEventListener('shopify:section:load', initializeSpace);
  })();

  } catch(e) { console.error(e); }
})();
})();
